import React, { useState, useEffect, useRef } from "react";
import { ChevronRight, X, Search } from "lucide-react";

const CustomSelect = ({
  options,
  isMulti = false,
  isSearchable = false,
  className = "",
  field,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleOption = (option) => {
    let newValue;
    if (isMulti) {
      newValue = Array.isArray(field.value)
        ? field.value.includes(option.value)
          ? field.value.filter((value) => value !== option.value)
          : [...field.value, option.value]
        : [option.value];
    } else {
      newValue = option.value;
      setIsOpen(false);
    }
    field.onChange(newValue);
  };

  const clearSelection = () => {
    field.onChange(isMulti ? [] : null);
  };

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const selectedOptions = isMulti
    ? options.filter(
        (option) =>
          Array.isArray(field.value) && field.value.includes(option.value)
      )
    : options.filter((option) => option.value === field.value);

  return (
    <div className={`custom-select ${className}`} ref={ref}>
      <div className="select-control" onClick={() => setIsOpen(!isOpen)}>
        <div className="selected-options">
          {!!selectedOptions.length &&
            selectedOptions.map((option) => (
              <span key={option.value} className="selected-option">
                {option.label}
              </span>
            ))}
        </div>
        <div className="select-actions">
          {selectedOptions.length > 0 && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                clearSelection();
              }}
              className="clear-button"
            >
              <X size={18} />
            </button>
          )}
          <ChevronRight
            size={18}
            className={`chevron ${isOpen ? "chevron-open" : ""}`}
          />
        </div>
      </div>
      {isOpen && (
        <div className="options-container">
          {isSearchable && (
            <div className="search-container">
              <div className="search-input-wrapper">
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Search className="search-icon" size={18} />
              </div>
            </div>
          )}
          <div className="options-list">
            {filteredOptions.map((option) => (
              <div
                key={option.value}
                className={`option ${
                  selectedOptions.some(
                    (selectedOption) => selectedOption.value === option.value
                  )
                    ? "selected"
                    : ""
                }`}
                onClick={() => toggleOption(option)}
              >
                <input
                  type="checkbox"
                  checked={selectedOptions.some(
                    (selectedOption) => selectedOption.value === option.value
                  )}
                  onChange={() => {}}
                  className="option-checkbox"
                />
                {option.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
